(function(){
    'use strict';

    angular.module('allegro')
        .controller('AllegroOfferListController', AllegroOfferListController);

    AllegroOfferListController.$inject = [
        '$scope',
        '$state',
        'lodashService',
        'notificationSrvc',
        'filterQuerySrvc',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'allegroOffersDataSrvc',
        'allegroOfferPermissionsConst',
        'allegroSrvc',
        'allegroOfferMessagesConst'
    ];

    function AllegroOfferListController(
        $scope, $state, lodashService, notificationSrvc, filterQuerySrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc,
        allegroOffersDataSrvc, allegroOfferPermissionsConst, allegroSrvc, allegroOfferMessagesConst
    ) {
        var self = this;

        self.loading = true;
        self.checkboxSelectedProp = "$$checkboxSelected";
        self.selectedRowCount = 0;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.modelRows = [];
        self.modelCols = [
            {
                title: 'ID Produktu',
                value: 'product',
                type: 'number',
                searchable: false,
                orderable: false
            },
            {
                title: 'Sygnatura',
                value: 'signature',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Numer oferty',
                value: 'external_id',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Tytuł',
                value: 'title',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Cena',
                value: 'price',
                type: 'number',
                searchable: false,
                orderable: false
            },
            {
                title: 'Czas wysyłki',
                value: 'delivery_handling_time_display',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Status publikacji',
                value: 'publication_status_display',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Data dodania',
                value: 'date_added',
                searchable: true,
                orderable: true,
            },
            {
                title: 'Data modyfikacji',
                value: 'date_modified',
                searchable: true,
                orderable: true,
            },
            {
                title: 'Edytowano przez',
                value: 'last_modified_by',
                searchable: true,
                orderable: true,
            }
        ];

        self.modelPermissions = allegroOfferPermissionsConst;
        self.searchQuery = {};
        self.filterData = {
            external_id: '',
            signature: '',
            title: '',
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.openDeliveryTimeHandlingChangeModal = openDeliveryTimeHandlingChangeModal;
        self.getSelectedModelIds = getSelectedModelIds;
        self.openPriceChangeModal = openPriceChangeModal;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.onFilterChange = onFilterChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getOffers();

            rowSelectWatch();
        }

        function rowSelectWatch(){
            $scope.$watch(
                function() {
                    return self.modelRows.map(function(row) {
                        return row[self.checkboxSelectedProp] || false;
                    });
                },
                function(newVals, oldVals) {
                    if (newVals !== oldVals) {
                        self.selectedRowCount = self.getSelectedModelIds().length;
                    }
                },
                true
            );
        }

        function getOffers(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    external_id: self.filterData.external_id,
                    signature: self.filterData.signature,
                    title: self.filterData.title,
                };
            }
            return allegroOffersDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.modelRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getOffers);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.allegro-offers.create');
        }

        function onEdit(row) {
            $state.go('layout.allegro-offers.create', { pk: row.pk });
        }

        function onDelete(row) {
            var title = row.external_id ? 'ofertę o numerze: ' + row.external_id : 'ofertę o ID: ' + row.pk;
            return allegroSrvc.removeOffer(title, row.pk, function(response) {
                notificationSrvc.notification("success", allegroOfferMessagesConst.delete);
                lodashService.remove(self.modelRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getOffers();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getOffers();
        }

        function onFilterChange() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getOffers();
        }

        function getSelectedModelIds(){
            var selectedModelIds = self.modelRows.reduce(function (filtered, row) {
                if (row[self.checkboxSelectedProp]) {
                    filtered.push(row.pk);
                }
                return filtered;
            }, []);
            return selectedModelIds;
        }

        function onDeliveryTimeHandlingChange(data){
            getOffers();
        }

        function openDeliveryTimeHandlingChangeModal() {
            var modelIds = self.getSelectedModelIds()
            allegroSrvc.deliveryTimeHandlingChangeModal(
                {offers: modelIds}, onDeliveryTimeHandlingChange, angular.noop
            )
        }

        function onPriceChange(data){
            getOffers();
        }

        function openPriceChangeModal() {
            var modelIds = self.getSelectedModelIds()
            allegroSrvc.priceChangeModal({offers: modelIds}, onPriceChange, angular.noop)
        }
    }
})();
